import * as Exp from './experimentConstants'

const defaultFeatureFlags = {
  // [flagName]: [defaultValue],
  test: false,
  dropshipping_skip_selection: false,
  // tslint:disable-next-line:max-line-length
  ca_bgc_checkr_redirect: false, // Flag for redirect vs no redirect conversion measurement
  dropshipping: false,
  dropshipping_ab: false,
  instant_dashing: false,
  canada_dropshipping_embed_checkr_flow: false,
  dropshipping_status: false,
  enable_i18n_language_selection: false,
  bank_onboarding: false,
  [Exp.RETURN_TO_APPLICATION_AUTO]: false,
  [Exp.DX_CRO_LP_GRADUATION_Q1_2020]: false,
  [Exp.DX_CRO_LP_GRADUATION_Q3_2020]: false,
  w9_experiment: false,
  orientation_experiment: false,
  [Exp.INSTANT_DASHING_V2]: false,
  dasher_signup_ui_refresh: false,
  background_check_experiment: false,
  application_status_experiment: false,
  in_app_education_v3: false,
  [Exp.DX_ID_FAST_PAY_Q1_2020]: false,
  [Exp.NEEDS_VEHICLE_INFO]: false,
  [Exp.W_MODEL_EXPERIMENT]: false,
  [Exp.DX_PHONE_NUMBER_VERIFICATION]: false,
}

export default defaultFeatureFlags
